import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "d-flex align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2" }
const _hoisted_4 = { class: "col-6 me-3" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputImage = _resolveComponent("InputImage")!
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
      _createVNode(_component_InputImage, {
        "onUpdate:modelValue": _ctx.documentKeyChanged,
        onImageCleared: _ctx.imageCleared,
        onPreviewUrlChanged: _ctx.previewUrlChanged,
        modelValue: _ctx.localDocumentKey,
        typeCode: _ctx.docType,
        module: _ctx.DpModuleEnum.CPC
      }, null, 8, ["onUpdate:modelValue", "onImageCleared", "onPreviewUrlChanged", "modelValue", "typeCode", "module"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localSvg) = $event)),
          rows: "4",
          placeholder: _ctx.$t('svgImage'),
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSvgChanged && _ctx.onSvgChanged(...args))),
          class: "form-control w-100"
        }, null, 40, _hoisted_5), [
          [_vModelText, _ctx.localSvg]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.hasSVG)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_BaseDeleteButton, {
                deleteData: _ctx.clearSVG,
                pageUI: _ctx.pageUI,
                class: "btn-sm me-3"
              }, null, 8, ["deleteData", "pageUI"]),
              _createElementVNode("div", {
                class: "category-svg-container",
                innerHTML: _ctx.localSvg
              }, null, 8, _hoisted_8)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}